import './ChannelLogo.scss';
import classNames from 'classnames';

export interface ChannelLogoProps {
  /** optional additional class */
  className?: string;
  /** small or large size */
  size?: 'small' | 'large';
  /** image source */
  src: string;
  /** image alt text */
  alt: string;
  /** callback fired when the image fails to load */
  onError?: React.ReactEventHandler<HTMLImageElement>;
}

/**
 * Channel Logo
 * @param className - optional class
 * @param size - small or large size
 * @param src - image source
 * @param alt - image alt text
 * @param onError - callback fired when the image fails to load
 */
export const ChannelLogo: React.FC<ChannelLogoProps> = ({
  className = '',
  size = 'large',
  src,
  alt,
  ...rest
}) => (
  <img
    src={src}
    alt={alt}
    className={classNames('vds-channel-logo', `vds-channel-logo--${size}`, className)}
    {...rest}
  />
);
